const padToTwoDigits = (time: number): string => {
    if (time > 10) return `${time}`;
    if (time > -10 && time < 0) return `-0${-time}`;
    if (time >= 0 && time < 10) return `0${time}`;

    return `${time}`;
};

const secondsToHhMmSs = (timeInSeconds: number): string => {
    if (typeof timeInSeconds !== 'number') return 'N/A';

    const seconds = timeInSeconds % 60;
    const minutes = Math.floor(timeInSeconds / 60) % 60;
    const hours = Math.floor(timeInSeconds / (60 * 60));

    const formattedSeconds = padToTwoDigits(seconds);
    const formattedMinutes = padToTwoDigits(minutes);
    const formattedHours = padToTwoDigits(hours);

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

const secondsToMmSs = (timeInSeconds: number): string => {
    if (typeof timeInSeconds !== 'number') return 'N/A';

    const seconds = timeInSeconds % 60;
    const minutes = Math.floor(timeInSeconds / 60);

    const formattedMinutes = padToTwoDigits(minutes);
    const formattedSeconds = padToTwoDigits(seconds);

    return `${formattedMinutes}:${formattedSeconds}`;
};

const secondsToMinutes = (timeInSeconds: number): string => {
    if (typeof timeInSeconds !== 'number') return 'N/A';
    return `${(timeInSeconds / 60).toFixed(2)}`; // Limit to two decimals
};

export { secondsToHhMmSs, secondsToMmSs, secondsToMinutes, padToTwoDigits };
